import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const TransactionDetailsByLotSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [25, 50, 100, 500, 1000, "all"];
    const gridKey = "6EB05910-FB64-4743-A9A3-240FF0E8B486";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="record" caption="Record#"  />
                <Column dataField="identityId" caption="Customer"   />
                <Column dataField="name" caption="Name"   />
                <Column dataField="transactionType" caption="Transaction Type"  />
                <Column dataField="transactionNumber" caption="Transaction#"   />
                <Column dataField="shipper" caption="Shipper"   />
                <Column dataField="status" caption="Status"  />
                <Column dataField="stage" caption="Stage"   />
                <Column dataField="transactionDate" caption="Transaction Date"   dataType="date" format="MM/dd/yyyy" />
                <Column dataField="amount" caption="Amount"   dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="shipperName" caption="Shipper Name" visible={false} />
                <Column dataField="consignee" caption="Consignee" visible={false} />
                <Column dataField="consigneeName" caption="Consignee Name" visible={false} />
                <Column dataField="shipperBOLNumber" caption="Shipper BOL Number" visible={false} />
                <Column dataField="stagingStartDate" caption="Staging Start Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="plannedReceivedShippedDateTime" caption="Planned Received Shipped Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="actualReceivedShippedDateTime" caption="Actual Received Shipped Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="equipmentInterchangeReport" caption="Equipment Interchange Report" visible={false} />
                <Column dataField="container" caption="Container" visible={false} />
                <Column dataField="reference" caption="Reference" visible={false} />
                <Column dataField="transportationMode" caption="Transportation Mode" visible={false} />
                <Column dataField="truckReference" caption="Truck Reference" visible={false} />
                <Column dataField="truckArrivalDateTime" caption="Truck Arrival Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="truckDepartDateTime" caption="Truck Depart Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="deliveryPickupPlannedDateTime" caption="Delivery Pickup Planned Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="deliveryPickupArriveDateTime" caption="Delivery Pickup Arrive Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="deliveryPickupDepartDateTime" caption="Delivery Pickup Depart Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="dispatchOrderNumber" caption="Dispatch Order Number" visible={false} />
                <Column dataField="thirdPartyBillType" caption="Third Party Bill Type" visible={false} />
                <Column dataField="pickStatus" caption="Pick Status" visible={false} />
                <Column dataField="freightChargeType" caption="Freight Charge Type" visible={false} />
                <Column dataField="freightAmount" caption="Freight Amount" visible={false} dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="codAmount" caption="COD Amount" visible={false} dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="codAmountCollected" caption="COD Amount Collected" visible={false} dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="codCollectionDateTime" caption="COD Collection Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="codPayMethod" caption="COD Pay Method" visible={false} />
                <Column dataField="taxBasis" caption="Tax Basis" visible={false} dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="taxRate" caption="Tax Rate" visible={false} dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="taxAmount" caption="Tax Amount" visible={false} dataType="number" format={{
                    type: "fixedPoint",
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="code1" caption="Code 1" visible={false} />
                <Column dataField="code2" caption="Code 2" visible={false} />
                <Column dataField="code3" caption="Code 3" visible={false} />
                <Column dataField="code4" caption="Code 4" visible={false} />
                <Column dataField="code5" caption="Code 5" visible={false} />
                <Column dataField="code6" caption="Code 6" visible={false} />
                <Column dataField="code7" caption="Code 7" visible={false} />
                <Column dataField="code8" caption="Code 8" visible={false} />
                <Column dataField="code9" caption="Code 9" visible={false} />
                <Column dataField="code10" caption="Code 10" visible={false} />
                <Column dataField="reference1" caption="Reference 1" visible={false} />
                <Column dataField="reference2" caption="Reference 2" visible={false} />
                <Column dataField="reference3" caption="Reference 3" visible={false} />
                <Column dataField="reference4" caption="Reference 4" visible={false} />
                <Column dataField="reference5" caption="Reference 5" visible={false} />
                <Column dataField="reference6" caption="Reference 6" visible={false} />
                <Column dataField="reference7" caption="Reference 7" visible={false} />
                <Column dataField="reference8" caption="Reference 8" visible={false} />
                <Column dataField="reference9" caption="Reference 9" visible={false} />
                <Column dataField="reference10" caption="Reference 10" visible={false} />
                <Column dataField="date1" caption="Date 1" visible={false} />
                <Column dataField="date2" caption="Date 2" visible={false} />
                <Column dataField="date3" caption="Date 3" visible={false} />
                <Column dataField="date4" caption="Date 4" visible={false} />
                <Column dataField="date5" caption="Date 5" visible={false} />
                <Column dataField="date6" caption="Date 6" visible={false} />
                <Column dataField="date7" caption="Date 7" visible={false} />
                <Column dataField="date8" caption="Date 8" visible={false} />
                <Column dataField="date9" caption="Date 9" visible={false} />
                <Column dataField="date10" caption="Date 10" visible={false} />
                <Column dataField="quantity1" caption="Quantity 1" visible={false} />
                <Column dataField="quantity2" caption="Quantity 2" visible={false} />
                <Column dataField="quantity3" caption="Quantity 3" visible={false} />
                <Column dataField="quantity4" caption="Quantity 4" visible={false} />
                <Column dataField="quantity5" caption="Quantity 5" visible={false} />
                <Column dataField="quantity6" caption="Quantity 6" visible={false} />
                <Column dataField="quantity7" caption="Quantity 7" visible={false} />
                <Column dataField="quantity8" caption="Quantity 8" visible={false} />
                <Column dataField="quantity9" caption="Quantity 9" visible={false} />
                <Column dataField="quantity10" caption="Quantity 10" visible={false} />
                <Column dataField="fiscalYear" caption="Fiscal Year" visible={false} />
                <Column dataField="fiscalPeriod" caption="Fiscal Period" visible={false} />
                <Column dataField="commitDate" caption="Commit Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="holdReason" caption="Hold Reason" visible={false} />
                <Column dataField="carrier" caption="Carrier" visible={false} />
                <Column dataField="carrierName" caption="Carrier Name" visible={false} />
                <Column dataField="transportCarrier" caption="Transport Carrier" visible={false} />
                <Column dataField="transportCarrierName" caption="Transport Carrier Name" visible={false} />
                <Column dataField="plnAppnmntResource" caption="Plan Appointment Resource" visible={false} />
                <Column dataField="plnAppnmntResourceHrs" caption="Plan Appointment Resource Hours" visible={false} />
                <Column dataField="plnAppnmntRef" caption="Plan Appointment Reference" visible={false} />
                <Column dataField="plnAppnmntComment" caption="Plan Appointment Comment" visible={false} />
                <Column dataField="stagingWH" caption="Staging Warehouse" visible={false} />
                <Column dataField="stagingArea" caption="Staging Area" visible={false} />
                <Column dataField="stagingStartDt" caption="Staging Start Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingFinishDt" caption="Staging Finish Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="assgndUnloadedBy" caption="Assigned Unloaded By" visible={false} />
                <Column dataField="assgndUnloadedPlnDt" caption="Assigned Unload Planned Date" visible={false} />
                <Column dataField="assgndCheckBy" caption="Assigned Check By" visible={false} />
                <Column dataField="assgndCheckByDt" caption="Assigned Check By Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="assgndPutAwayBy" caption="Assigned Put Away By" visible={false} />
                <Column dataField="assgndPutAwayByDt" caption="Assigned Put Away By Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="dockYardWH" caption="Dock Yard Warehouse" visible={false} />
                <Column dataField="dockYardLoc" caption="Dock Yard Location" visible={false} />
                <Column dataField="department" caption="Department" visible={false} />
                <Column dataField="departmentDescription" caption="Department Description" visible={false} />
                <Column dataField="job" caption="Job" visible={false} />
                <Column dataField="jobDescription" caption="Job Description" visible={false} />
                <Column dataField="fund" caption="Fund" visible={false} />
                <Column dataField="fundDescription" caption="Fund Description" visible={false} />
                <Column dataField="fmTruckReference" caption="FM Truck Reference" visible={false} />
                <Column dataField="fmDriverReference" caption="FM Driver Reference" visible={false} />
                <Column dataField="fmTrailerReference" caption="FM Trailer Reference" visible={false} />
                <Column dataField="transportationYardLeaveDate" caption="Transportation Yard Leave Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="transportDriverID" caption="Transport Driver ID" visible={false} />
                <Column dataField="transportDriverName" caption="Transport Driver Name" visible={false} />
                <Column dataField="transportTrailerID" caption="Transport Trailer ID" visible={false} />
                <Column dataField="transportTruckID" caption="Transport Truck ID" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransactionDetailsByLotSubTab);